if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      connectedCallback() {
        const variantsScript = this.querySelector('script[data-variants]');
        if (!variantsScript) return;
        try {
          this.variants = JSON.parse(variantsScript.textContent);
        } catch (e) {
          return;
        }
        this.sectionId = this.dataset.section;
        this.addEventListener('change', this.onChange.bind(this));
      }

      onChange() {
        const variant = this.findVariantFromSelection();
        if (!variant) return;
        this.updateVariantIdInForms(variant);
        this.updateUrl(variant);
        this.updatePrice(variant);
        this.updateRecipientFormVariantId(variant);
      }

      findVariantFromSelection() {
        const selected = this.getSelectedOptions();
        return this.variants.find(
          (v) =>
            Array.isArray(v.options) &&
            v.options.length === selected.length &&
            v.options.every((opt, i) => opt === selected[i])
        );
      }

      getSelectedOptions() {
        const groups = this.querySelectorAll('fieldset, .product-form__input--dropdown');
        return Array.from(groups).map((group) => {
          const radio = group.querySelector('input[type="radio"]:checked');
          if (radio) return radio.value;
          const select = group.querySelector('select');
          if (select) return select.value;
          return null;
        });
      }

      updateVariantIdInForms(variant) {
        ['product-form-', 'product-form-installment-'].forEach((prefix) => {
          const form = document.getElementById(prefix + this.sectionId);
          if (!form) return;
          const idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = variant.id;
        });
      }

      updateUrl(variant) {
        if (!variant.id) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      updatePrice(variant) {
        const priceContainer = document.getElementById('price-' + this.sectionId);
        if (!priceContainer) return;
        const priceEl =
          priceContainer.querySelector('.price-item--regular') ||
          priceContainer.querySelector('.price__regular .price-item') ||
          priceContainer.querySelector('.price-item');
        if (!priceEl) return;
        const currency = window.Shopify?.currency?.active || 'USD';
        try {
          priceEl.textContent = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency,
          }).format((variant.price ?? 0) / 100);
        } catch (e) {
          /* ignore */
        }
      }

      updateRecipientFormVariantId(variant) {
        const recipientForm = document.querySelector(
          `recipient-form[data-section-id="${this.sectionId}"]`
        );
        if (recipientForm) recipientForm.dataset.productVariantId = variant.id;
      }
    }
  );
}
